/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Upload_PdfsInputs */

const en_features_upload_pdfs = /** @type {(inputs: Features_Upload_PdfsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs`)
};

const es_features_upload_pdfs = /** @type {(inputs: Features_Upload_PdfsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs`)
};

/**
* | output |
* | --- |
* | "PDFs" |
*
* @param {Features_Upload_PdfsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_upload_pdfs = /** @type {((inputs?: Features_Upload_PdfsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Upload_PdfsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_upload_pdfs(inputs)
	return en_features_upload_pdfs(inputs)
});